import React, { useState } from 'react';
import { Card, CardContent } from "../ui/card";
import StripeCheckout from './StripeCheckout';

const SubscriptionPlansDisplay = ({ 
  loading, 
  availedTrials,
  onSelectPlan,
  isOnboarding
}) => {
  // Use environment variables for Stripe price IDs
  const PRICE_IDS = {
    basic: process.env.REACT_APP_STRIPE_BASIC_PRICE_ID,
    pro: process.env.REACT_APP_STRIPE_PRO_PRICE_ID
  };
  
  const anyTrialAvailedOverall = availedTrials && 
                              typeof availedTrials === 'object' && 
                              Object.keys(availedTrials).length > 0;
  
  if (process.env.NODE_ENV !== 'production') {
    console.log(`[SubscriptionPlansDisplay] Trial check - availedTrials:`, availedTrials);
    console.log(`[SubscriptionPlansDisplay] Trial check - anyTrialAvailedOverall:`, anyTrialAvailedOverall);
    
    const effectiveTrialAvailable = isOnboarding ? true : !anyTrialAvailedOverall;
    
    console.log(`[SubscriptionPlansDisplay] effectiveTrialAvailable:`, effectiveTrialAvailable);
  }

  const effectiveTrialAvailable = isOnboarding ? true : !anyTrialAvailedOverall;

  const isPlanTrialAvailed = (planId) => {
    return availedTrials && 
           typeof availedTrials === 'object' && 
           !!availedTrials[planId];
  };
  
  const [planLoading, setPlanLoading] = useState(null);

  const handleSelectPlan = async (planId, isTrial) => {
    setPlanLoading(planId);
    try {
      // Determine if this is a trial or paid flow
      const isTrialFlow = effectiveTrialAvailable && isTrial;
      const valueToPass = isTrialFlow ? planId : PRICE_IDS[planId];
      await onSelectPlan(valueToPass, isTrialFlow);
    } catch (err) {
      // Optionally handle error
    } finally {
      setPlanLoading(null);
    }
  };

  return (
    <div className="space-y-6">
      <Card className="app-card-bg border-border">
        <CardContent className="pt-6">
          <h3 className="text-xl font-bold text-accent-foreground mb-4">
            {isOnboarding ? "Complete Your Setup" : "Select a Plan"}
          </h3>
          <p className="text-primary mb-6">
            Choose a plan that suits your needs. All plans come with a 60-day free trial.
          </p>
          <StripeCheckout 
            loading={loading || !!planLoading}
            availedTrials={availedTrials}
            onSelectPlan={handleSelectPlan}
            planLoading={planLoading}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionPlansDisplay;
